<style  lang="scss">
// .ant-select-dropdown {
//   width: 262px !important;
// }

.custom-all__label {
  div {
    display: none;
  }
}

.month-picker__input {
  .ant-calendar-picker-input {
    border-radius: 10px;
    font-size: 14px;

    .ant-calendar-picker-input {
      margin-top: -8px;
    }
  }
}

.ant-select-selection--multiple {
  max-height: 40px;
}

.ant-select {
  height: 40px;
}

.ant-select-dropdown-menu-item {
  border-bottom: 1px solid #ededed;
}

.ant-select-dropdown-menu-item:last-child {
  border-bottom: none;
}

.ant-select-selection__placeholder {
  font-size: 14px;
}

.ant-select-selection {
  border-radius: 10px !important;
}

.ant-radio-wrapper {
  margin-bottom: 3px;
}

.ant-radio-wrapper {
  margin-right: 0 !important;

  span {
    padding-right: 0;
  }
}
</style>
<style lang="scss" scoped>
.wrapper {
  padding: 20px 10px 4px 10px;
  .header {
    text-align: center;
    margin-bottom: 20px;

    h4 {
      font-size: 18px;
      font-weight: 700;
      color: #303c54;
    }
  }

  .select-group__wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    flex-wrap: wrap;
    column-gap: 14px;
    margin-bottom: 20px;

    .option-group__wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      row-gap: 5px;
      column-gap: 12px;
    }

    .select-group__left {
      margin-bottom: 10px;
    }

    .select-group__divider {
      height: 71px;
      border-right: 1px solid #d8d8d8;
    }

    .select-group__right {
      width: 151px;

      .time-content {
        font-size: 12px;
        margin-bottom: 6px;
        color: #303c54;
      }
      .month-picker__wrapper {
        padding: 0 0 13px 0;
      }
    }
  }

  .chart {
    height: 575px;
  }

  .bottom {
    margin-top: 10px;
    display: flex;
    justify-content: center;

    img {
      margin-right: 6px;
    }

    span {
      font-weight: bold;
      line-height: 14px;
    }
  }
}

.chart-title {
  margin-bottom: 15px;

  h4.card-title {
    padding-left: 15px;
  }

  h4.line-chart {
    padding-left: 30px;
  }
}

@media only screen and (max-device-width: 1024px) {
  .mb-tablet-4 {
    margin-bottom: 2rem;
  }
  h4.line-chart.mb-0 {
    padding-right: 1px;
  }
}
</style>
<template>
  <div class="wrapper">
    <div class="header">
      <h4>Biến động nhân sự theo thâm niên</h4>
    </div>
    <div class="select-group__wrapper">
      <div class="select-group__left">
        <a-radio-group
          v-model="checkRadio"
          @change="onChangeRadio"
          class="option-group__wrapper"
        >
          <a-radio value="1">
            <a-select
              mode="multiple"
              placeholder="Công ty"
              style="width: 98px"
              size="large"
              option-label-prop="label"
              v-model="value"
              @select="handleSelect"
              @deselect="handleSelect"
              :showArrow="true"
              :maxTagCount="0"
              class="select__drop"
              :disabled="selectDisable(1)"
              @blur="handleBlur"
            >
              <template #suffixIcon>
                <div>
                  <img src="../../assets/img/arrow.svg" alt="" />
                </div>
              </template>
              <a-select-option
                v-for="option in 1"
                :key="'companyAll' + option"
                label="All"
              >
                <a-checkbox v-model="checkAll"> </a-checkbox>
                All
              </a-select-option>
              <a-select-option
                v-for="(option, index) in companyOptions"
                :key="'company' + index"
                :value="option.value"
                :label="option.label"
              >
                <a-checkbox v-model="option.isChecked"> </a-checkbox>
                {{ option.label }}
              </a-select-option>
            </a-select>
          </a-radio>
          <a-radio value="2">
            <a-select
              mode="multiple"
              placeholder="Khối"
              style="width: 98px"
              size="large"
              option-label-prop="label"
              v-model="footsValue"
              @select="handleSelectDivisions"
              @deselect="handleSelectDivisions"
              @blur="handleFootBlur"
              :showArrow="true"
              :maxTagCount="0"
              class="select__drop"
              :disabled="selectDisable(2)"
            >
              <template #suffixIcon>
                <div>
                  <img src="../../assets/img/arrow.svg" alt="" />
                </div>
              </template>
              <a-select-option
                v-for="option in 1"
                :key="'footAll' + option"
                label="All"
              >
                <a-checkbox v-model="footsCheckAll"> </a-checkbox>
                All
              </a-select-option>
              <a-select-option
                v-for="(option, index) in footOption"
                :key="'foot' + index"
                :value="option.value"
                :label="option.label"
              >
                <a-checkbox v-model="option.isChecked"> </a-checkbox>
                {{ option.label }}
              </a-select-option>
            </a-select>
          </a-radio>
          <a-radio value="3">
            <a-select
              preventDefault
              mode="multiple"
              placeholder="Bộ phận"
              style="width: 98px"
              size="large"
              option-label-prop="label"
              v-model="divisionValue"
              :showArrow="true"
              :maxTagCount="0"
              class="select__drop"
              @select="handleSelectDivision"
              @blur="handleDivisionBlur"
              @deselect="handleSelectDivision"
              :disabled="selectDisable(3)"
            >
              <template #suffixIcon>
                <div>
                  <img src="../../assets/img/arrow.svg" alt="" />
                </div>
              </template>
              <a-select-opt-group label="all" :class="'custom-all__label'">
                <a-select-option
                  v-for="(option, index) in 1"
                  :key="index"
                  label="All"
                >
                  <a-checkbox v-model="divisionCheckAll"></a-checkbox>
                  All
                </a-select-option>
              </a-select-opt-group>
              <a-select-opt-group
                v-for="(divisionOption, index) in divisionOptions"
                :key="divisionOption.label"
                :label="divisionOption.label"
              >
                <a-select-option
                  v-for="(option, i) in divisionOptions[index].options"
                  :key="i"
                  :value="option.value"
                  :label="option.label"
                >
                  <a-checkbox v-model="option.isChecked"> </a-checkbox>
                  {{ option.label }}
                </a-select-option>
              </a-select-opt-group>
            </a-select>
          </a-radio>
        </a-radio-group>
      </div>
      <div class="select-group__divider"></div>
      <div class="select-group__right">
        <div class="time-content">Mốc thời gian xét thâm niên</div>
        <div class="month-picker__wrapper">
          <a-month-picker
            placeholder="YYYY-MM"
            size="large"
            v-model="monthSelect"
            @change="onChange"
            :disabled-date="disabledDate"
            :class="'month-picker__input'"
          >
            <template slot="suffixIcon">
              <img src="../../assets/img/calendar.svg" alt="" />
            </template>
          </a-month-picker>
        </div>
      </div>
    </div>
    <div>
      <v-chart class="chart" :option="chartOption" autoresize />
    </div>
    <div class="bottom">
      <img src="img/icons/note.svg" alt="" />
      <span>Thâm niên tính từ thời điểm tham gia công ty</span>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import { use } from "echarts/core";
import {
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  PolarComponent,
} from "echarts/components";
import { BarChart, LineChart, PictorialBarChart } from "echarts/charts";
import { UniversalTransition } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";
import VChart from "vue-echarts";
use([
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BarChart,
  LineChart,
  CanvasRenderer,
  PolarComponent,
  UniversalTransition,
  PictorialBarChart,
]);

export default {
  metaInfo() {
    return {
      title: "Dashboard",
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  components: {
    VChart,
  },
  data() {
    return {
      chartOption: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
          textStyle: {
            fontFamily:
              "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji",
          },
        },
        grid: {
          show: false,
          top: "9%",
          left: "4%",
          right: "4%",
          bottom: "1%",
          containLabel: true,
        },
        legend: {
          data: ["Số lượng", "Tỷ lệ"],
          width: "50%",
          itemHeight: 16,
          itemWidth: 16,
          textStyle: {
            fontFamily:
              "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji",
          },
          selectedMode: false,
        },
        xAxis: [
          {
            type: "category",
            data: [
              "~2 tháng",
              "~6 tháng",
              "~12 tháng",
              "1 năm ~",
              "2 năm ~",
              "3 năm ~",
              "4 năm ~",
              "5 năm ~",
            ],
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              color: "#303C54",
              interval: 0,
              fontSize: 12,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#D8D8D8",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "Số lượng\n(người)",
            min: 0,
            max: function (value) {
              if (value.max == 0) {
                return 0;
              }
              return Math.ceil(value.max / 50) * 50;
            },
            // interval: 10,
            axisLabel: {
              formatter: "{value}",
              textStyle: {
                color: "#8F9194",
              },
            },
            splitLine: {
              lineStyle: {
                type: [5, 10],
                dashOffset: 5,
              },
            },
            nameTextStyle: {
              color: "#8F9194",
              lineHeight: 20,
            },
            position: "left",
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#D8D8D8",
              },
            },
          },
          {
            type: "value",
            name: "Tỷ lệ",
            min: 0,
            axisLabel: {
              formatter: "{value} %",
              textStyle: {
                color: "#8F9194",
              },
            },
            splitLine: {
              lineStyle: {
                type: [5, 10],
              },
            },
            nameTextStyle: {
              color: "#8F9194",
              lineHeight: 50,
            },
            position: "right",
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#D8D8D8",
              },
            },
          },
        ],
        series: [
          {
            name: "Số lượng",
            type: "bar",
            tooltip: {
              valueFormatter: function (value) {
                return value;
              },
            },
            barWidth: "70%",
            data: [],
            // clip: true,
            // label: {
            //   normal: {
            //     show: true,
            //     position: "top",
            //     fontWeight: "bold",
            //     fontFamily:
            //       "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji",
            //   },
            // },
            // z: 10,
            itemStyle: {
              color: "#2F8757",
            },
          },
          {
            name: "Tỷ lệ",
            type: "line",
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return Math.round(value * 100) / 100 + "%";
              },
            },
            colorBy: "series",
            symbol: "circle",
            symbolSize: 10,
            symbolKeepAspect: true,
            itemStyle: {
              color: "#EBAB71",
            },
            lineStyle: {
              width: 3,
            },
            data: [],
          },
          {
            type: "pictorialBar",
            symbolSize: [0, 0],
            tooltip: {
              show: false,
            },
            symbolPosition: "end",
            label: {
              show: true,
              position: "top",
              fontSize: 14,
              fontWeight: "bold",
              color: "#303C54",
              fontFamily:
                "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji",
            },
            z: 10,
            data: [],
          },
        ],
      },
      companyOptions: [],
      footOption: [],
      divisionOptions: [],
      value: [],
      footsValue: [],
      footName: {},
      divisionValue: [],
      checkRadio: "1",
      checkAll: false,
      footsCheckAll: false,
      divisionCheckAll: false,
      searchOption: {
        type: null,
        codes: null,
        month: null,
      },
      monthSelect: moment().format("YYYY-MM"),
    };
  },
  async created() {
    await this.getEmployeeSeniority();

    Object.keys(this.companies).forEach((item) => {
      this.companyOptions.push({
        label: this.companies[item].name,
        value: item,
        isChecked: false,
      });
    });

    Object.keys(this.foots).forEach((foot) => {
      this.footOption.push({
        label: this.foots[foot].name,
        value: this.foots[foot].code,
        isChecked: false,
      });
      this.footName[foot] = this.foots[foot].name;
    });

    const key = "parent_code";
    var groupDivisions = this.divisions.reduce((hash, obj) => {
      if (obj[key] === undefined) return hash;
      return Object.assign(hash, {
        [obj[key]]: (hash[obj[key]] || []).concat(obj),
      });
    }, {});

    Object.keys(groupDivisions).forEach((groupDivision) => {
      let key = Object.keys(this.foots).find(
        (key) => this.foots[key].code === groupDivision
      );
      this.divisionOptions.push({
        label: this.foots[key].name,
        options: [],
      });
    });

    for (let i = 0; i < this.divisionOptions.length; i++) {
      for (let j = 0; j < Object.values(groupDivisions)[i].length; j++) {
        this.divisionOptions[i].options.push({
          value: Object.values(groupDivisions)[i][j].code,
          label: Object.values(groupDivisions)[i][j].name,
          isChecked: false,
        });
      }
    }
    this.handleSelect("companyAll1");
  },

  computed: {
    ...mapGetters({
      companies: "commons/companies",
      foots: "commons/foots",
      divisions: "commons/divisions",
      employeeFluctuating: "dashboard/employeeFluctuating",
    }),
  },

  watch: {
    value() {
      this.value.length === this.companyOptions.length
        ? (this.checkAll = true)
        : (this.checkAll = false);
    },

    footsValue() {
      this.footsValue.length === this.footOption.length
        ? (this.footsCheckAll = true)
        : (this.footsCheckAll = false);
    },

    divisionValue() {
      let footOptionLength = null;
      for (let i = 0; i < this.divisionOptions.length; i++) {
        footOptionLength += this.divisionOptions[i].options.length;
      }
      this.divisionValue.length === footOptionLength
        ? (this.divisionCheckAll = true)
        : (this.divisionCheckAll = false);
    },
  },

  methods: {
    ...mapActions("layout", ["setLoading"]),

    disabledDate(current) {
      const monthStart = moment("2018-07").startOf("day");
      const monthEnd = moment().endOf("day");
      return !(monthStart.isSameOrBefore(current) && monthEnd.isAfter(current));
    },

    async handleBlur() {
      if (this.checkRadio == 1) {
        this.searchOption.type = "company";
        this.searchOption.codes = this.value;
        this.searchOption.month = this.monthSelect
          ? moment(this.monthSelect).format("YYYY-MM")
          : null;
        await this.getEmployeeSeniority(this.value.length);
      }
    },

    async handleFootBlur() {
      if (this.checkRadio == 2) {
        this.searchOption.type = "foot";
        this.searchOption.codes = this.footsValue;
        this.searchOption.month = this.monthSelect
          ? moment(this.monthSelect).format("YYYY-MM")
          : null;
        await this.getEmployeeSeniority(this.footsValue.length);
      }
    },

    async handleDivisionBlur() {
      if (this.checkRadio == 3) {
        this.searchOption.type = "department";
        this.searchOption.codes = this.divisionValue;
        this.searchOption.month = this.monthSelect
          ? moment(this.monthSelect).format("YYYY-MM")
          : null;
        await this.getEmployeeSeniority(this.divisionValue.length);
      }
    },

    async getEmployeeSeniority(check) {
      try {
        await this.$store.dispatch(
          "dashboard/getEmployeeFluctuating",
          this.searchOption
        );
        this.chartOption.series[0].data = [];
        this.chartOption.series[1].data = [];
        this.chartOption.series[2].data = [];
        if (check != 0) {
          Object.keys(this.employeeFluctuating).forEach((item) => {
            this.chartOption.series[0].data.push(
              this.employeeFluctuating[item].total
            );
            this.chartOption.series[1].data.push(
              this.employeeFluctuating[item].rate * 100
            );
            this.chartOption.series[2].data.push(
              this.employeeFluctuating[item].total
            );
          });
        } else {
          Object.keys(this.employeeFluctuating).forEach((item) => {
            this.chartOption.series[0].data.push(
              (this.employeeFluctuating[item].total = 0)
            );
            this.chartOption.series[1].data.push(
              (this.employeeFluctuating[item].rate = 0)
            );
            this.chartOption.series[2].data.push(
              (this.employeeFluctuating[item].total = 0)
            );
          });
        }
      } catch (e) {
        return;
      }
    },

    async onChange() {
      this.searchOption.month = this.monthSelect?.format("YYYY-MM") ?? null;
      await this.getEmployeeSeniority();
    },

    selectDisable(data) {
      return this.checkRadio == data ? false : true;
    },

    onChangeRadio() {
      switch (this.checkRadio) {
        case "1":
          this.divisionValue = [];
          this.footsValue = [];
          this.uncheckDivision();
          this.uncheckFoot();
          this.handleSelect("companyAll1");
          this.handleBlur();
          break;
        case "2":
          this.value = [];
          this.divisionValue = [];
          this.uncheckCompany();
          this.uncheckFoot();
          this.handleSelectDivisions("footAll1");
          this.handleFootBlur();
          break;
        case "3":
          this.value = [];
          this.footsValue = [];
          this.uncheckDivision();
          this.uncheckCompany();
          this.handleSelectDivision(0);
          this.handleDivisionBlur();
          break;
      }
    },

    uncheckCompany(data) {
      for (let i = 0; i < this.companyOptions.length; i++) {
        if (data === false) {
          this.companyOptions[i].isChecked = true;
          this.value.push(this.companyOptions[i].value);
        } else {
          this.companyOptions[i].isChecked = false;
        }
      }
    },

    uncheckDivision(data) {
      for (let i = 0; i < this.footOption.length; i++) {
        if (data === false) {
          this.footOption[i].isChecked = true;
          this.footsValue.push(this.footOption[i].value);
        } else {
          this.footOption[i].isChecked = false;
        }
      }
    },

    uncheckFoot(data) {
      for (let i = 0; i < this.divisionOptions.length; i++) {
        for (let j = 0; j < this.divisionOptions[i].options.length; j++) {
          if (data === false) {
            this.divisionOptions[i].options[j].isChecked = true;
            this.divisionValue.push(this.divisionOptions[i].options[j].value);
          } else {
            this.divisionOptions[i].options[j].isChecked = false;
          }
        }
      }
    },

    handleSelect(e) {
      if (e === "companyAll1") {
        let optionSelect = this.value.slice(1);
        this.value = [];
        optionSelect.length < this.companyOptions.length
          ? this.uncheckCompany(false)
          : this.uncheckCompany();
      }
      let key = Object.keys(this.companyOptions).find(
        (key) => this.companyOptions[key].value === e
      );
      if (key) {
        this.companyOptions[key].isChecked =
          !this.companyOptions[key].isChecked;
      }
    },

    handleSelectDivisions(e) {
      if (e === "footAll1") {
        let optionSelect = this.footsValue.slice(1);
        this.footsValue = [];
        optionSelect.length < this.footOption.length
          ? this.uncheckDivision(false)
          : this.uncheckDivision();
      }
      let key = Object.keys(this.footOption).find(
        (key) => this.footOption[key].value === e
      );
      if (key) {
        this.footOption[key].isChecked = !this.footOption[key].isChecked;
      }
    },

    handleSelectDivision(e) {
      if (e === 0) {
        let optionSelect = this.divisionValue.slice(1);
        let footOptionLength = null;
        this.divisionValue = [];

        for (let i = 0; i < this.divisionOptions.length; i++) {
          footOptionLength += this.divisionOptions[i].options.length;
        }

        optionSelect.length < footOptionLength
          ? this.uncheckFoot(false)
          : this.uncheckFoot();
      }

      this.divisionOptions.forEach((element) => {
        let key = Object.keys(element.options).find(
          (key) => element.options[key].value === e
        );

        if (element.options[key]) {
          element.options[key].isChecked = !element.options[key].isChecked;
        }
      });
    },
  },
};
</script>
